import { errors, readOnly } from '@yola/ws-sdk';

const readOnlyModeDecorator =
  (fn) =>
  (...args) => {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      errors.operations.catchError(null, errors.types.READ_ONLY_ERROR);
      return;
    }

    fn(...args);
  };

export default readOnlyModeDecorator;
